import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  commisionsDescription: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  arrowIcon: {
    position: 'relative',
    cursor: 'pointer',
    transition: '0.3s',
  },
  hasCommisionItem: {
    borderBottomStyle: 'dashed',
  },
  commisionItem: {
    backgroundColor: '#eee',
    '& > td': {
      borderBottom: 'none',
      '&:last-child': { paddingRight: 10 },
    },
  },
}));
